<div class="sidenav">
  <ul class="sidenav-nav">
    <li
      class="sidenav-nav-item"
      [routerLink]="['/herosection']"
      routerLinkActive="active"
    >
      <img class="side-logo" src="/assets/images/logo-sidebaar.png" alt="" />
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/herosection']"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a class="sidenav-nav-link">Hero Section </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/imporatntUpdate']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Important Update </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/upcomingEvents']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Upcoming Events </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/gallerySection']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Gallery </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/videoSection']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Video </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/latestnews']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Latest News </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/whoiswho']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> Who's Who </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/externallink']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link"> External Link </a>
    </li>
    <li
      class="sidenav-nav-item"
      [routerLink]="['/circular']"
      routerLinkActive="active"
    >
      <a class="sidenav-nav-link">
        Circular , Gov Guidelines & NCMM Notification
      </a>
    </li>
  </ul>
</div>
